import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
const criteria = [{
  yes: 'Tu hijo tiene entre 4 y 7 años',
  no: 'Buscás clases para adultos'
}, {
  yes: 'Reconoce letras pero no logra leer palabras',
  no: 'No querés involucrarte en el proceso'
}, {
  yes: 'Querés ayudarlo desde casa',
  no: 'Esperás resultados sin práctica'
}, {
  yes: 'Buscás una guía clara paso a paso',
  no: 'Tu hijo ya lee fluidamente'
}, {
  yes: 'Necesitás una rutina simple',
  no: 'Esperás una solución mágica sin involucrarte'
}];
export function IsThisForYou() {
  return <section className="py-12 md:py-16 bg-white" data-id="element-185">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-186">
        <div className="text-center mb-8" data-id="element-187">
          <h2 className="text-3xl md:text-5xl font-bold text-navy" data-id="element-188">
            ¿ESTE SISTEMA ES PARA VOS?
          </h2>
        </div>

        <div className="rounded-3xl border border-slate-100 overflow-hidden shadow-sm" data-id="element-189">
          <table className="w-full table-fixed border-collapse" data-id="element-190">
            <thead data-id="element-191">
              <tr data-id="element-192">
                <th className="w-1/2 bg-emerald-50 border-b border-emerald-100/70 px-3 py-4 sm:px-5" data-id="element-193">
                  <div className="flex items-center justify-center gap-2" data-id="element-194">
                    <CheckCircle2 className="w-5 h-5 text-emerald-600 flex-shrink-0" data-id="element-195" />
                    <span className="text-sm sm:text-lg font-bold text-emerald-900" data-id="element-196">
                      SÍ ES PARA VOS
                    </span>
                  </div>
                </th>
                <th className="w-1/2 bg-rose-50 border-b border-l border-rose-100/70 px-3 py-4 sm:px-5" data-id="element-197">
                  <div className="flex items-center justify-center gap-2" data-id="element-198">
                    <XCircle className="w-5 h-5 text-rose-500 flex-shrink-0" data-id="element-199" />
                    <span className="text-sm sm:text-lg font-bold text-rose-900" data-id="element-200">
                      NO ES PARA VOS
                    </span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody data-id="element-201">
              {criteria.map((c, i) => <tr key={i} className="align-top" data-id="element-202">
                  <td className="bg-emerald-50/40 border-b border-emerald-100/50 px-3 py-3 sm:px-5 sm:py-4" data-id="element-203">
                    <div className="flex items-start gap-2" data-id="element-204">
                      <CheckCircle2 className="w-4 h-4 sm:w-5 sm:h-5 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-205" />
                      <span className="text-xs sm:text-base text-emerald-900 font-medium leading-snug" data-id="element-206">
                        {c.yes}
                      </span>
                    </div>
                  </td>
                  <td className="bg-rose-50/40 border-b border-l border-rose-100/50 px-3 py-3 sm:px-5 sm:py-4" data-id="element-207">
                    <div className="flex items-start gap-2" data-id="element-208">
                      <XCircle className="w-4 h-4 sm:w-5 sm:h-5 text-rose-400 flex-shrink-0 mt-0.5" data-id="element-209" />
                      <span className="text-xs sm:text-base text-rose-900 leading-snug" data-id="element-210">
                        {c.no}
                      </span>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}